
import React from 'react';
  
const Blogs = () => {
  return (
    <h1>You can write your blogs!</h1>
  );
};
  
export default Blogs;